export const footerContent = {
    es: {
        blurb: 'Ofrecemos los mejores servicios de IPTV. Nuestro servicio es simple, rápido y fiable. Puedes disfrutar de tus canales favoritos en cualquier dispositivo, estés donde estés.',
        quickLinks: 'Enlaces rápidos',
        refundLink: 'Política de Reembolso',
        privacyLink: 'Política de Privacidad',
        termsLink: 'Términos y Condiciones de Uso',
        contact: 'Contacto',
        weAccept: 'Aceptamos',
        copyright: '© LIGUEE1 - contact@liguee1.com',
    },
};
